import { createFileRoute } from "@tanstack/react-router";

import PersonList from "/src/routes/person/list/PersonList";
import { personListSearchSchema } from "/src/routes/person/list/personListSearch";

export type { PersonListSearch } from "/src/routes/person/list/personListSearch";

export const Route = createFileRoute("/_main/person/list")({
  validateSearch: personListSearchSchema,
  component: PersonList,
});
